/**
 * handleForm.js
 *
 * Copyright (c) apploft. GmbH
 */

import {Path, APIDefinition} from 'apploft-cloud-client';
import {presentingForm} from '../ContentStateSymbol';

export default function handleForm({section, api}) {
  const paths = APIDefinition.pathsMatching(section, api);
  const widgetProps = Path.findPostProps(paths);

  return {state: presentingForm, data: {widgetProps, section, api}};
}
